module.exports = __webpack_public_path__ + "static/media/save.055e6272.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/ftyc/img/save.png
 ** module id = 1460
 ** module chunks = 0
 **/